module.exports = __webpack_public_path__ + "img/mountains.a7cebb0c.jpg";